import React from 'react';
import PropTypes from 'prop-types';
import {Message} from '@aperza/ui';

export default class StockLabel extends React.Component {

  static numberOfStocks = {
    numberOfStocks: PropTypes.number.isRequired,
    salesMethodMaker: PropTypes.bool.isRequired,
    salesMethodLabel: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
  }

  render() {

    let numberOfStocks = Number(this.props.numberOfStocks, 10);
    let numberOfStocksFormatted= numberOfStocks.toLocaleString();
    let salesMethodMaker = Boolean(this.props.salesMethodMaker);
    let salesMethodLabel = this.props.salesMethodLabel;

    if (!this.props) {
      return (null);
    }

    if (salesMethodMaker) {
      return <p className="item-stock green" dangerouslySetInnerHTML={{__html:salesMethodLabel}}></p>
    } else {
      if (numberOfStocks > 9) {
        return <p className="item-stock green"><Message messageId="stock.inStock" values={{numberOfStocks: numberOfStocksFormatted}} escapeHtml={true} /></p>
      } else if(numberOfStocks > 0 && numberOfStocks <= 9) {
        return <p className="item-stock red"><Message messageId="stock.limitedStock" values={{numberOfStocks: numberOfStocksFormatted}}  /></p>
      } else if(numberOfStocks <= 0) {
        return <p className="item-stock noStock"><Message messageId="stock.noStock" /></p>
      } else {
        return (null)
      }
    }
  }
}
